import 'Shared/ko/ko.stopBinding';
import 'Shared/ko/ko.visibleWhen';
import 'Shared/ko/ko.swiper';
import 'Shared/ko/ko.lightBox';
import 'Shared/ko/ko.lightGallery';
import 'Shared/ko/ko.piediagram';
import 'Shared/ko/ko.spinner';
import 'Shared/ko/ko.rangeFilter';
import 'Shared/ko/ko.typeahead';
import 'Shared/ko/ko.selectpicker';
import 'Shared/ko/ko.scrollbar';
import 'Shared/ko/ko.statusbar';
import 'Shared/ko/ko.sortable';
import 'Shared/ko/ko.observe';
import 'Shared/ko/ko.brwatch';
import 'Shared/ko/ko.autosize';
import 'Shared/ko/ko.map';
import 'Shared/ko/ko.extenders';


ko.subscribable.fn.subscribeChanged = function (callback) {
    if (!this.previousValueSubscription) {
        this.previousValueSubscription = this.subscribe(function (_previousValue) {
            this.previousValue = _previousValue;
        }, this, 'beforeChange');
    }
    return this.subscribe(function (latestValue) {
        callback(latestValue, this.previousValue);
    }, this);
};